import { useEffect, useState } from "react";
import axios from "axios";
import { FaVideo, FaMicrophone } from "react-icons/fa";
import { useToast } from "@chakra-ui/react";

const VideoCallRoomGroupConfig = () => {
  const toast = useToast();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [config, setConfig] = useState({
    videoConfig: {
      adminCommissionPercentage: "",
      femaleCommissionPercentage: "",
      hostCommissionPercentage: "",
      maxVideoMembers: "",
       videoSessionDurationMinutes: "",
       coinsPerMinute:""
    },
    audioConfig: {
      adminCommissionPercentage: "",
      femaleCommissionPercentage: "",
      hostCommissionPercentage: "",
      maxAudioMembers: "",
      audioSessionDurationMinutes: "", // ✅ ADD
    },
    isActive: true,
  });

  // ================= FETCH CONFIG =================
  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      setLoading(true);

      const res = await axios.get("/api/v1/admin/group-call-config");

      /**
       * ✅ CORRECT PATH BASED ON YOUR RESPONSE
       */
      const apiConfig = res?.data?.data?.config;

      if (!apiConfig) return;

      setConfig({
        videoConfig: {
          adminCommissionPercentage:
            String(apiConfig.videoConfig?.adminCommissionPercentage ?? ""),
          femaleCommissionPercentage:
            String(apiConfig.videoConfig?.femaleCommissionPercentage ?? ""),
          hostCommissionPercentage:
            String(apiConfig.videoConfig?.hostCommissionPercentage ?? ""),
          maxVideoMembers: String(
            apiConfig.videoConfig?.maxVideoMembers ?? ""
          ),
           videoSessionDurationMinutes: String( // ✅ ADD
    apiConfig.videoConfig?.videoSessionDurationMinutes ?? ""
  ),
  coinsPerMinute: String( // ✅ ADD
    apiConfig.videoConfig?.coinsPerMinute ?? ""
  )
        },
        audioConfig: {
          adminCommissionPercentage:
            String(apiConfig.audioConfig?.adminCommissionPercentage ?? ""),
          femaleCommissionPercentage:
            String(apiConfig.audioConfig?.femaleCommissionPercentage ?? ""),
          hostCommissionPercentage:
            String(apiConfig.audioConfig?.hostCommissionPercentage ?? ""),
          maxAudioMembers: String(
            apiConfig.audioConfig?.maxAudioMembers ?? ""
          ),
           audioSessionDurationMinutes: String( // ✅ ADD
    apiConfig.audioConfig?.audioSessionDurationMinutes ?? ""
  ),
        },
        isActive: apiConfig.isActive ?? true,
      });
    } catch (error) {
      toast({
        title: "Error loading configuration",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // ================= INPUT HANDLER =================
  const handleInputChange = (type, field, value) => {
    setConfig((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [field]: value, // keep string for controlled input
      },
    }));
  };

  // ================= SAVE CONFIG =================
  const handleSave = async () => {
    try {
      setSaving(true);

      /**
       * ✅ BACKEND EXPECTS THIS SHAPE
       */
      const payload = {
        videoConfig: {
          adminCommissionPercentage: Number(
            config.videoConfig.adminCommissionPercentage
          ),
          femaleCommissionPercentage: Number(
            config.videoConfig.femaleCommissionPercentage
          ),
          hostCommissionPercentage: Number(
            config.videoConfig.hostCommissionPercentage
          ),
          maxVideoMembers: Number(config.videoConfig.maxVideoMembers),
          videoSessionDurationMinutes: Number( // ✅ ADD
    config.videoConfig.videoSessionDurationMinutes
  ),
  coinsPerMinute: String( // ✅ ADD
    config.videoConfig?.coinsPerMinute ?? ""
  )
        },
        audioConfig: {
          adminCommissionPercentage: Number(
            config.audioConfig.adminCommissionPercentage
          ),
          femaleCommissionPercentage: Number(
            config.audioConfig.femaleCommissionPercentage
          ),
          hostCommissionPercentage: Number(
            config.audioConfig.hostCommissionPercentage
          ),
          maxAudioMembers: Number(config.audioConfig.maxAudioMembers),
           audioSessionDurationMinutes: Number( // ✅ ADD
    config.audioConfig.audioSessionDurationMinutes
  ),
        },
        isActive: config.isActive,
      };

      const res = await axios.put("/api/v1/admin/group-call-config", payload);

      if (res.data?.status === "OK") {
        toast({
          title: "Configuration updated successfully!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error saving configuration",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSaving(false);
    }
  };

  // ================= LOADING =================
  if (loading) {
    return (
      <div className="p-6 max-w-5xl mx-auto flex justify-center">
        <div className="w-8 h-8 animate-spin border-4 border-yellow-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div className="p-6 max-w-5xl mx-auto bg-white text-[var(--yellow)]">
      <h1 className="text-2xl font-bold mb-6 flex items-center gap-2">
        <FaVideo /> Group Call Configuration
      </h1>

      {/* ================= VIDEO CONFIG ================= */}
      <Section title="Video Call Config" icon={<FaVideo />}>
        <Input
          label="Admin %"
          value={config.videoConfig.adminCommissionPercentage}
          onChange={(e) =>
            handleInputChange(
              "videoConfig",
              "adminCommissionPercentage",
              e.target.value
            )
          }
        />
        <Input
          label="Female %"
          value={config.videoConfig.femaleCommissionPercentage}
          onChange={(e) =>
            handleInputChange(
              "videoConfig",
              "femaleCommissionPercentage",
              e.target.value
            )
          }
        />
        <Input
          label="Host %"
          value={config.videoConfig.hostCommissionPercentage}
          onChange={(e) =>
            handleInputChange(
              "videoConfig",
              "hostCommissionPercentage",
              e.target.value
            )
          }
        />
        <Input
          label="Max Members"
          value={config.videoConfig.maxVideoMembers}
          onChange={(e) =>
            handleInputChange(
              "videoConfig",
              "maxVideoMembers",
              e.target.value
            )
          }
        />
        <Input
  label="Session Duration (Minutes)"
  value={config.videoConfig.videoSessionDurationMinutes}
  onChange={(e) =>
    handleInputChange(
      "videoConfig",
      "videoSessionDurationMinutes",
      e.target.value
    )
  }
/>

<Input
  label="Coins per Join(Male)"
  value={config.videoConfig.coinsPerMinute}
  onChange={(e) =>
    handleInputChange(
      "videoConfig",
      "coinsPerMinute",
      e.target.value
    )
  }
/>

        <div className="mt-6 flex justify-start col-span-full">
          <button
            onClick={handleSave}
            disabled={saving}
            className="px-6 py-3 bg-[var(--yellow)] text-white rounded-lg disabled:opacity-50 hover:bg-opacity-90 transition-colors"
          >
            {saving ? "Saving..." : "Save Configuration"}
          </button>
        </div>

      </Section>

      {/* ================= AUDIO CONFIG ================= */}
      {/* <Section title="Audio Call Config" icon={<FaMicrophone />}>
        <Input
          label="Admin %"
          value={config.audioConfig.adminCommissionPercentage}
          onChange={(e) =>
            handleInputChange(
              "audioConfig",
              "adminCommissionPercentage",
              e.target.value
            )
          }
        />
        <Input
          label="Female %"
          value={config.audioConfig.femaleCommissionPercentage}
          onChange={(e) =>
            handleInputChange(
              "audioConfig",
              "femaleCommissionPercentage",
              e.target.value
            )
          }
        />
        <Input
          label="Host %"
          value={config.audioConfig.hostCommissionPercentage}
          onChange={(e) =>
            handleInputChange(
              "audioConfig",
              "hostCommissionPercentage",
              e.target.value
            )
          }
        />
        <Input
          label="Max Members"
          value={config.audioConfig.maxAudioMembers}
          onChange={(e) =>
            handleInputChange(
              "audioConfig",
              "maxAudioMembers",
              e.target.value
            )
          }
        />
             <Input
  label="Session Duration (Minutes)"
  value={config.audioConfig.audioSessionDurationMinutes}
  onChange={(e) =>
    handleInputChange(
      "audioConfig",
      "audioSessionDurationMinutes",
      e.target.value
    )
  }
/>
      </Section> */}
 


    </div>
  );
};

// ================= REUSABLE COMPONENTS =================
const Section = ({ title, icon, children }) => (
  <div className="bg-[var(--black)] rounded-xl p-6 border-2 border-gray-300 mb-8 w-full">
    <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
      {icon} {title}
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">{children}</div>
  </div>
);

const Input = ({ label, value, onChange }) => (
  <div>
    <label className="text-sm mb-1 block">{label}</label>
    <input
      type="number"
      value={value}
      onChange={onChange}
      className="w-full p-2 border-2 border-[var(--yellow)] bg-white text-[var(--yellow)] rounded-lg"
    />
  </div>
);

export default VideoCallRoomGroupConfig;
